import { MessageToMerchant } from "../remoteAction";

interface SendKeyDownParams {
  code: string;
  ctrlKey: boolean;
  metaKey: boolean;
  shiftKey: boolean;
}

export type SendKeyDownAction = MessageToMerchant<
  "KEY_DOWN",
  SendKeyDownParams
>;

export function sendKeyDown(params: SendKeyDownParams): SendKeyDownAction {
  const { code, ctrlKey, metaKey, shiftKey } = params;

  return {
    type: "SEND_MESSAGE_TO_MERCHANT",
    payload: {
      type: "KEY_DOWN",
      data: { code, ctrlKey, metaKey, shiftKey },
    },
  };
}
